export const Config = {
  API_URL: 'https://cstest.infinityevcharge.com/v1',
  REACT_APP_API_KEY: 'AIzaSyBa0yPphimIer5WqWyEes0Ui6qOu9MuNQE',
  EMITTER_URL: 'staging.realtime.infinityevcharge.com',
}
